import { useEffect, useState } from "react";
import { Modal, Button, Alert } from "../../ui";

export default function ConfirmActionModal({
  isOpen,
  title,
  message,
  confirmLabel = "Confirm",
  confirmVariant = "primary",
  onClose,
  onConfirm,
}) {
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setError("");
  }, [isOpen]);

  const handleConfirm = async () => {
    setError("");
    setLoading(true);
    try {
      await onConfirm();
      onClose();
    } catch (err) {
      setError(err.response?.data?.message || err.message || "Something went wrong");
    }
    setLoading(false);
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title} size="sm"
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>Cancel</Button>
          <Button variant={confirmVariant} loading={loading} onClick={handleConfirm}>
            {confirmLabel}
          </Button>
        </>
      }
    >
      {error && (
        <Alert variant="danger" className="mb-4" onDismiss={() => setError("")}>{error}</Alert>
      )}
      <p className="text-theme-bodycolor dark:text-themedark-bodycolor">{message}</p>
    </Modal>
  );
}
